<!-- =========================================================================================
  File Name: ProductionRulesList.vue
  Description: Production Rules List
  ----------------------------------------------------------------------------------------
  Item Name: Vaagai Tecknowledge - Easy Admin
  Author: Vaagai Tecknowledge
  Author URL: http://www.vaagai.org.in/
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-popup title="Add Production Rule" :active.sync="addRecordPrompt">
      <production-rules-add-new :addRecordPrompt="addRecordPrompt" @hideAddRecordPrompt="hideAddRecordPrompt" v-if="addRecordPrompt"></production-rules-add-new>
    </vs-popup>
    
    <vs-popup title="Edit Production Rule" :active.sync="editRecordPrompt">
      <production-rules-edit :editRecordPrompt="editRecordPrompt" @hideEditRecordPrompt="hideEditRecordPrompt" v-if="editRecordPrompt" :recordIndex="recordToEdit" ></production-rules-edit>
    </vs-popup>    

    <fab :actions="btnActions" @addbtn="addRecordPrompt = true" @editbtn="editAlert(selected)" @deletebtn="deleteAlert(selected)" :position="btnPosition" :start-opened="btnOpened" :main-icon="btnIcon" :toggle-when-away="btnToggle" :main-tooltip="btnTooltp" :fixed-tooltip="fixedTooltip" :ripple-show="btnShow" :ripple-color="btnColor" :icon-size="btnSize" ></fab>

    <!-- <p class="text-danger">{{ message }}</p>
    <h4 class="text-success text-center">{{ successTxt }}</h4>
    <h4 class="text-danger text-center">{{ errorTxt }}</h4> -->
    
    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="rows">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span>Delete</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Archive</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Print</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Another Action</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->

        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ rows.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : rows.length }} of {{ rows.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="sno"> # </vs-th>
        <vs-th sort-key="ProductName"> Product Name </vs-th>
        <vs-th sort-key="ExpectedQty"> Expected Outcome </vs-th>
        <vs-th sort-key="RawMaterialsCount"> Total </vs-th>
        <vs-th sort-key="PrimaryProductsTxt"> Primary Raw Material </vs-th>
        <vs-th sort-key="SecondaryProductsTxt"> Secondary Raw Material </vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                {{ tr.sno }}
              </vs-td>

              <vs-td>
                <!-- <vs-chip :color="getOrderStatusColor(tr.active_status)" class="product-order-status">
                  {{ tr.active_status }}
                </vs-chip> -->
                {{ tr.ProductName }} {{ tr.ProductDescription }}
              </vs-td>

              <vs-td>
                {{ tr.ExpectedQty }} {{ tr.UnitSymbol }}
              </vs-td>

              <vs-td>
                {{ tr.RawMaterialsCount }}
              </vs-td>

              <vs-td>
                {{ tr.PrimaryProductsTxt }}
              </vs-td>

              <vs-td>
                {{ tr.SecondaryProductsTxt }}
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import fab from 'vue-fab'
import ProductionRulesAddNew from "./ProductionRulesAddNew.vue"
import ProductionRulesEdit from "./ProductionRulesEdit.vue"

var successTxt = '';
var errorTxt = '';
/*
const username=this.$session.get('username');
const role=this.$session.get('role');
const token=this.$session.get('token');
*/
export default {
  mixins: [common],
  components: {
    fab,
    ProductionRulesAddNew,
    ProductionRulesEdit
  },
  data() {
    // console.log('username='+username+', role='+role+', token'+token);
    return {
      btnPosition: 'bottom-right',
      btnOpened: false,
      btnIcon: 'more',
      btnToggle: true,
      btnTooltp: 'More Actions',
      fixedTooltip: false,
      btnShow: true,
      btnColor: 'light',
      btnSize: 'medium',
      switch2: true,
      btnActions: [],
      activeConfirm: false,
      selected: [],
      // rows: [],
      itemsPerPage: 10,
      isMounted: false,
      message: '',
      successTxt,
      errorTxt,
      addRecordPrompt: false,
      editRecordPrompt: false,
      recordToEdit: "",
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    
    rows() {
      return this.$store.getters['productionRules/dataList'];
    },
    
  },
  methods: {
    hideAddRecordPrompt(){
      console.log('hideAddRecordPrompt called');
      this.addRecordPrompt = false;
    },
    hideEditRecordPrompt(){
      console.log('hideEditRecordPrompt called');
      this.editRecordPrompt = false;
    },    
    backPage() {
      this.$router.go(-1);
    },
    getOrderStatusColor(status) {
      if(status == 'on hold') return "warning"
      if(status == 'Active') return "success"
      if(status == 'Inactive') return "danger"
      return "primary"
    },
    addData(){
      var params = {};
      var url = '/ledgers/group/create';
      this.pageRedirect(params, url);
    },

    editAlert(tr) {

      console.log('tr='+tr);
      var n = Object.keys(tr).length;
      console.log('n='+n);
      if (n > 0) {

        var id=tr.GstSlabId;
        var details=tr.GstSlabValue;
        console.log('id='+id+', details='+details);

        var alert_title='Edit Production Rule details';
        var alert_text='Do you want to edit '+details+' Production Rule details?';

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: alert_title,
          text: alert_text,
          accept: this.editData
        });
        // this.deleteRecords(where, url, destination, list_url);
        
      } else {
        var output = 'Kindly select record to edit';
        this.errorMessage(output);
      }
      
    },
    
    editData(){
      var selected = this.selected;
      var n = Object.keys(selected).length;
      var id=selected.GstSlabId;
      // var id=selected.sno - 1;
      var index = this.rows.map(e => e.GstSlabId).indexOf(id);
      console.log('n='+n);
      console.log('id='+id+', index='+index);
      if (id >= 0) {
        this.recordToEdit= index;
        this.editRecordPrompt = true;
      }
    },

    deleteAlert(tr) {

      console.log('tr='+tr);
      var n = Object.keys(tr).length;
      console.log('n='+n);
      if (n > 0) {

        var id=tr.GstSlabId;
        var details=tr.GstSlabValue;
        console.log('id='+id+', details'+details);

        var alert_title='Delete Production Rule details';
        var alert_text='Do you want to delete '+details+' Production Rule details?';

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: alert_title,
          text: alert_text,
          accept: this.deleteData
        });
        // this.deleteRecords(where, url, destination, list_url);
        
      } else {
        var output = 'Kindly select record to delete';
        this.errorMessage(output);
      }
      
    },
      
    deleteData(){
      var selected = this.selected;
      var n = Object.keys(selected).length;
      var id=selected.GstSlabId;
      var gst_slab_value=selected.GstSlabValue;
      console.log('n='+n+', id='+id+', gst_slab_value='+gst_slab_value);

      var server_url=companyConfig.apiURL;
      var record={};
      record.token=this.$session.get('token');
      record.delete_url=server_url+'lib/api/production/rules/delete';
      record.where={
        'gst_slab_id': id,
        'gst_slab_value': gst_slab_value
      };
      record.list_url=server_url+'lib/api/production/rules/lists';
      record.list_where={};
      console.log('deleteData record='+JSON.stringify(record));
      record.loading=this.$vs.loading;
      record.notify=this.$vs.notify;
      record.http=this.$http;      
      this.$store.dispatch('productionRules/deleteRecordDetails', record);     
    },

  },
  beforeCreate: function () {    
    if (!this.$session.exists()) {
      console.log('your session is expired');
      this.$router.push('/');
    }    
  },
  beforeMount() {
    if (!this.$session.exists()) {
      console.log('your session is expired');
      this.$router.push('/');      
    }else{
      
      var server_url=companyConfig.apiURL;
      var role=this.$session.get('role');
      console.log('server_url='+server_url+', role='+role);
      if (role != "") {
        this.btnActions.push(
          {
            name: 'addbtn',
            icon: 'add',
            tooltip: 'Add',
            color: '#28c76f'
          },
          /*
          {
              name: 'editbtn',
              icon: 'edit',
              tooltip: 'Edit',
              color: '#7367f0'
          },
          {
              name: 'deletebtn',
              icon: 'delete',
              tooltip: 'Delete',
              color: '#ea5455'
          },
          */
        );
      }
      
      var getAllRecords={};
      getAllRecords.token=this.$session.get('token');
      getAllRecords.list_url=server_url+'lib/api/production/rules/lists';
      getAllRecords.list_where={
        "where": {
          "production_rules_product_company_relation_id >=": 1
        },
        "or_where": {}
      };
      console.log('server_url='+server_url+', beforeMount getAllRecords='+JSON.stringify(getAllRecords));
      getAllRecords.loading=this.$vs.loading;
      getAllRecords.notify=this.$vs.notify;
      getAllRecords.http=this.$http;
      this.$store.dispatch('productionRules/loadAllRecords', getAllRecords);

    }
  },
  mounted() {
    this.pageLoadingOff();
    this.isMounted = true;    
  }
}
</script>

<style lang="scss">

#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 .3rem;
      // padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            // padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            // padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

</style>
